import { ColumnsV2, TextV2, styled } from '@withjoy/joykit';

export const StyledColumns = styled(ColumnsV2)`
  > div > div > div {
    width: 100%;
    margin: 0px;
    > div:first-child {
      padding-top: 0px;
      padding-left: 0px;
    }
    > div:last-child {
      padding-top: 0px;
      padding-right: 0px;
    }
  }
`;

export const StyledErrorText = styled(TextV2)`
  color: ${props => props.theme.colors.negative6};
`;
